import Vue from 'vue'
import Router from 'vue-router'
import DashBoard from '@/components/dashboard'
import redirect from '@/components/redirect'
import Login from '@/components/login/login'
import Constractor from '@/components/constractor/constractor'
import Rfifra from '@/outside/rfirfa/main'
import Changepwd from '@/components/passwd/changepwd'
import manageuser from '@/components/manageuser/manageuser'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'DashBoard',
      component: DashBoard
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: redirect
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/manageuser',
      name: 'manageuser',
      component: manageuser
    },
    {
      path: '/changepwd',
      name: 'changepwd',
      component: Changepwd
    },
    {
      path: '/Constractor',
      name: 'constractor',
      component: Constractor
    },
    {
      path: '/rfirfa',
      name: 'rfirfa',
      component: Rfifra
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js